<template>
  <div class="home">
    <!-- <AnnouncementBanner
      name="desyncWarning"
      v-if="!upToDate && topics.length && feed"
      :msg="desyncMsg"
    /> -->
    <HeroBlock :upnext="whosOnFirst" />
    <FilterBlock
      v-observe-visibility="handleScroll"
      :categories="categories"
      :options.sync="filterOptions"
      :counter="sortedTopics.length"
      @update:options="$set(this, 'filterOptions', $event)"
    />

    <transition-group name="sorting">
      <WonderfulTopic
        class="sorting"
        :scrollTransition="scrollTransition"
        :key="topic.id"
        :most_recent_ep="mostRecentEp"
        :spoiler_mode="filterOptions.spoilerMode"
        :small_wonder_mode="filterOptions.smallWonderMode"
        v-for="(topic, i) in sortedTopics"
        v-bind="topic"
        :index="i"
      ></WonderfulTopic>
    </transition-group>
  </div>
</template>
<script>
const gsheets = require("gsheets");
import Feed from "feed-to-json-promise";

import FilterBlock from "@/components/FilterBlock";
import HeroBlock from "@/components/HeroBlock";
import WonderfulTopic from "../components/WonderfulTopic";
import AnnouncementBanner from "../components/AnnouncementBanner";

import parameterize from "parameterize-string";

export default {
  name: "home",
  data() {
    return {
      scrollTransition: false,
      hosts: ["Griffin", "Rachel"],
      topics: [],
      feed: [],
      filterOptions: {
        search: "",
        sortBy: "ep_num",
        spoilerMode: true,
        smallWonderMode: false,
        sortAsc: false,
        selectedCategory: "All categories"
      },
      desyncMsg:
        'I\'m missing topics. <a href="https://twitter.com/GerCarney" target="_blank">Ger</a> & <a href="https://twitter.com/CianMarkey" target="_blank">Cian</a> are on it.'
    };
  },
  components: {
    FilterBlock,
    HeroBlock,
    WonderfulTopic,
    AnnouncementBanner
  },
  computed: {
    categories() {
      return [
        "All categories",
        ...new Set(this.topics.map(t => t.category).sort())
      ];
    },
    filteredTopics() {
      return this.topics.filter(topic => {
        if (!this.matchesSearch(topic)) {
          return false;
        }

        if (this.filterOptions.selectedCategory != "All categories") {
          if (topic.category != this.filterOptions.selectedCategory) {
            return false;
          }
        }

        if (
          topic.ep_num === this.mostRecentEp &&
          this.filterOptions.spoilerMode
        ) {
          return false;
        }

        if (topic.small_wonder && !this.filterOptions.smallWonderMode) {
          return false;
        }

        return true;
      });
    },
    sortedTopics() {
      return this.filteredTopics.sort((a, b) => {
        const by = this.filterOptions.sortBy;
        // If it's a string, force it to lowercase
        const valA = typeof a[by] == "string" ? parameterize(a[by]) : a[by];
        const valB = typeof b[by] == "string" ? parameterize(b[by]) : b[by];

        let result = 0;
        if (valA < valB) {
          result = 1;
        } else if (valA > valB) {
          result = -1;
        } else {
          result = a.id > b.id ? 1 : -1;
          result = !this.filterOptions.sortAsc ? result : result * -1;
        }

        return !this.filterOptions.sortAsc ? result : result * -1;
      });
    },
    whosOnFirst() {
      if (!Number.isInteger(this.mostRecentEp)) {
        return "...";
      }

      // Get the most recent ep
      let ep = this.mostRecentEp;

      // Get the corresponding topics - Ignore if it's a small wonder
      let arr = this.topics.filter(
        topic => topic.ep_num === ep && topic.small_wonder === false
      );

      // Add fix for the 'All Small Wonders' episode
      if (!arr.length) {
        arr = this.topics.filter(
          topic => topic.ep_num === ep && topic.micro === false
        );
      }
      // Get the id of the first one
      let id = Math.min(...arr.map(topic => topic.id));

      // Find its corresponding topic
      let lastFirstTopic = arr.find(topic => {
        return topic.id === id;
      });

      // Find the index of the selected host
      let selectedHostIndex = this.hosts.indexOf(lastFirstTopic.host);

      // Calculate if we're an odd/even number of episodes late
      let missedEpisodeOffset = this.upToDate ? 1 : 0;

      // Use that index to select the correct host
      selectedHostIndex = (selectedHostIndex + missedEpisodeOffset) % 2;

      return selectedHostIndex === 0 ? "Griffin" : "Rachel";
    },
    mostRecentEp() {
      return Math.max(...this.topics.map(topic => topic.ep_num));
    },
    upToDate() {
      if (!this.feed.length) return;
      return this.feed[0].title.includes(this.mostRecentEp.toString());
    }
  },
  methods: {
    matchesSearch(topic) {
      const searchVal = this.filterOptions.search.toLowerCase();
      const name = topic.name.toLowerCase();
      //const host = topic.host.toLowerCase();
      const ep_title = topic.ep_title.toLowerCase();

      return name.includes(searchVal) || ep_title.includes(searchVal);
    },
    handleScroll(e) {
      this.scrollTransition = !e;
    },

    async getTopicsJson(jsonUrl) {
      const response = await fetch(jsonUrl);
      const json = await response
        .json()
        .then(test => test.data)
        .catch(err => console.error(err));

      let topics = json.map((topic, i) => ({
        ...topic,
        id: i,
        small_wonder: topic.small_wonder == "TRUE" ? true : false,
        micro: topic.micro == "TRUE" ? true : false
      }));

      this.$set(this, "topics", topics);
    },
    async getFeed(feedUrl) {
      const feed = new Feed({
        timeout: 10000
      });

      feed
        .load(feedUrl)
        .then(feed => {
          let wonderful = /^Wonderful/;
          const filteredRSS = feed.items.filter(episode => {
            return wonderful.test(episode.title);
          });

          this.$set(this, "feed", filteredRSS);
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  async created() {
    this.getTopicsJson(
      "https://s3-eu-west-1.amazonaws.com/wonderful-json/topics.json"
    );
    this.getFeed("https://feeds.simplecast.com/w1teXNny");
  },

  mounted() {
    console.log(
      `
 _ _ _           _         ___     _
| | | |___ ___ _| |___ ___|  _|_ _| |
| | | | . |   | . | -_|  _|  _| | | |
|_____|___|_|_|___|___|_| |_| |___|_|

  		`
    );
  }
};
</script>
<style lang="scss" scoped>
h2 {
  color: #ccc;
}
</style>
